import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditProfileQueryData, SubmitEditProfileData } from 'globals/store/share.data';
import { Exhibitor, exhibitorProps } from 'globals/store/exhibitors.data';
import { ShareWrapper } from './share-wrapper.component';
import { JoiFile } from 'globals/store/files.model';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { ExhibitorEditFormComponent } from './share.editExhibitorForm.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';

@Component({
    selector: 'share-edit-exhibitor',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !exhibitor" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your details have been submitted.
  </div>
  <share-edit-exhibitor-form *ngIf="!!exhibitor && !submitted"
    [topTitle]="(exhibitor.name || 'Unnamed Exhibitor') + ' Profile in ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [exhibitor]="exhibitor"
    [publishCode]="publishCode"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="template"
    (onSubmit)="submit()">
  </share-edit-exhibitor-form>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    styles: [`
      add-assets { margin-bottom: 10px; }
      ::ng-deep add-assets .add_btn { text-align: left !important; }
    `],
    standalone: true,
    imports: [CommonModule, ExhibitorEditFormComponent, BrandingWrapperComponent]
})
export class ExhibitorEditComponent extends ShareWrapper<ExhibitorEditComponent> {
    publishCode:string;
    props = exhibitorProps
    newFiles: JoiFile[] = []
    oldFiles: JoiFile[]
    eventId;
    eventName: string
    cannotSubmitMessage = "The exhibitor profile can't be submitted at this time.\nPlease reload this page and try again."
    exhibitor: Exhibitor
    inactiveUrlMessage = "The exhibitor profile is not currently available for editing.\n\nTo review or update your profile, please contact the event organiser and ask them to re-activate your edit profile webform."
    invalid = false
    changed = false
    CTAInvalid = false
    customQuestions: CustomQuestion[] = []
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const queryData: EditProfileQueryData = { publishCode:this.publishCode, entityType: 'exhibitor' }
          this.publicService.loadEditProfile(queryData).then(profile => {
            this.loading = false;
            if (!profile) {
              document.title = "Unavailable";
              return
            }
            // console.log(profile)
            this.loading = false;
            this.exhibitor = profile.entity as Exhibitor
            this.eventId = profile.eventId
            this.eventName = profile.eventName
            this.oldFiles = profile.oldFiles
            document.title = "Edit exhibitor "+this.exhibitor.name;
            this.customQuestions = profile.customQuestions || []
            this.brandingData = profile.brandingData
            this.template = profile.brandingData?.template
          }).catch(e => {
            console.log(e)
            this.loading = false;
            document.title = "Unavailable";
          })
        }
        document.title = "loading";
      })
    }

    checkLinkOK() { // so can show it's okay after typing a valid start
      const url = this.exhibitor.callToActionUrl
      if (!url || this.helpers.urlOk(url)) this.CTAInvalid = false
    }

    checkLink() {
      const url = this.exhibitor.callToActionUrl
      this.CTAInvalid = !!url && !this.helpers.urlOk(url)
    }


    async submit(){
      this.processing = true;
      const data: SubmitEditProfileData = {
        publishCode:this.publishCode,
        entity:this.exhibitor,
        eventId: this.eventId,
        entityType: 'exhibitor',
        newFiles: this.newFiles.map(f => ({...f, by_uid: this.exhibitor.id }))
      }
      console.log(data)
      const successfullySubmitted = await this.publicService.submitEditProfile(data)
      this.processing = false;
      if (successfullySubmitted) this.submitted = true;
      else this.showError(this.cannotSubmitMessage)
    }
}

